module.exports = __webpack_public_path__ + "static/media/win.6a915d6c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/win.gif
// module id = 55
// module chunks = 0